import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Alert, AlertType } from './alert.model';
import { Subscription } from 'rxjs';
import { AlertService } from './alert.service';
import { MatLegacySnackBarRef as MatSnackBarRef, MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';
import { SnackbarType } from '../enums/enums';

@Component({
  selector: 'xcdrs-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  public SnackbarType = SnackbarType;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackRef: MatSnackBarRef<AlertComponent>
    
  ) { }

  ngOnInit(): void {
  }

  dismiss() {
    this.snackRef.dismiss();
  }
}